import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-horoscope'

export function getPageType(slug) {
	if (slug === '/magazin/horoscopo/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
